'use client';

import { useIntl } from 'react-intl';

import { Chip } from '@packages/shared/src/ui/Chip/Chip';

import type { FilterRangeValue } from '../../types';
import { messages } from '../SelectedFilterValueChip/SelectedFilterValueChip';

export type SelectedFilterRangeChipProps = {
  value: FilterRangeValue;
  onDelete: () => void;
};

/**
 * SelectedFilterRangeChip component description displayed in storybook
 * */
export const SelectedFilterRangeChip = ({ value, onDelete }: SelectedFilterRangeChipProps) => {
  const { formatMessage } = useIntl();

  const label = `${value.range.join('-')} ${value.unit}`;

  return (
    <Chip
      label={label}
      onDelete={onDelete}
      ariaLabelForDelete={formatMessage(messages.deleteLabel, { name: label })}
      variant="filled"
    />
  );
};
